module.exports = __webpack_public_path__ + "assets/img/inndot.a333ce1b.jpg";